import React from 'react';
import { Formik } from 'formik';
import { useToast } from '@chakra-ui/react';
import useGenericMutationUseCase from '../../../hooks/usecases/generic/useGenericMutationUseCase';
import { localise, templateReplace } from '../../../services/lang/lang';
import SuspenseWrapper from '../SuspenseWrapper/SuspenseWrapper';
import FormikModalErrorSync from '../Modal/FormikModalErrorSync';
import { useUpdateOfficerAssessment } from '../../../services/api/generated/client';
import RenderIfElse from '../RenderIf/RenderIfElse';
import OfficerAssessmentDetailsFormWrapper from './OfficerAssessmentDetailsFormWrapper';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import OfficerAssessmentDetailsFormShareWrapper from './Share/OfficerAssessmentDetailsFormShareWrapper';
const EditOfficerAssementWrapper = ({ canEdit, onMutated, officerAssessment, }) => {
    const { isShare } = useInspectionDetailContext();
    const updateOfficerAssessment = useGenericMutationUseCase(useUpdateOfficerAssessment);
    const toast = useToast();
    const initialValues = {
        hazards: officerAssessment.hazards.map((hazard) => hazard.id),
        action_type_id: officerAssessment.action_type?.id,
    };
    const onSubmit = (values, helpers) => {
        updateOfficerAssessment.execute({
            officerAssessmentId: officerAssessment.id,
            data: values,
        }, helpers, {
            onSuccess: () => {
                onMutated?.();
                helpers.resetForm({
                    values,
                });
                toast({
                    title: templateReplace(localise('UPDATED'), {
                        noun: localise('OFFICER_ASSESSMENT'),
                    }),
                    status: 'success',
                    isClosable: true,
                });
            },
        });
    };
    return (React.createElement(SuspenseWrapper, null,
        React.createElement(Formik, { initialValues: initialValues, onSubmit: onSubmit },
            React.createElement(React.Fragment, null,
                React.createElement(FormikModalErrorSync, null),
                React.createElement(RenderIfElse, { condition: !!isShare, then: React.createElement(OfficerAssessmentDetailsFormShareWrapper, { officerAssessment: officerAssessment }), else: React.createElement(OfficerAssessmentDetailsFormWrapper, { canEdit: canEdit }) })))));
};
export default EditOfficerAssementWrapper;
